export const i18n = {
  timezone: "Pacific/Auckland",
};
